export default "__VITE_ASSET__BMSNAswA__"